<template>
	<div class="remote-management-page">
		<div class="section breath-panel">
			<!-- 头部标题 -->
			<div class="header">
				<h2 class="title">远程管理</h2>
				<span class="tip">参数配置 / 远程控制 / 指令记录</span>
			</div>

			<!-- 标签切换 -->
			<div class="tabs">
				<div :class="{'tab-btn':true,active:tabKey == item.deviceType}" @click="tabClick(item)"
					v-for="item of remote_maintenanceData.deviceTypes" :key="item.deviceType">{{item.typeName}}</div>
			</div>

			<!-- 设备表格 -->
			<div class="device-table">
				<div class="table-header">
					<div class="col">设备名称</div>
					<div class="col">位置</div>
					<div class="col">协议</div>
					<div class="col">采样频率</div>
					<div class="col">上报阈值</div>
					<div class="col">操作</div>
				</div>
				<div :class="{'table-row':true,upgrading:item.tag=='upgrading' }" v-for="(item, index) in deviceList"
					:key="index">
					<div class="col text-ellipsis">
						<span class="version-tag" :class="item.tag">{{ item.statusName }}</span>
						{{ item.deviceName }}
					</div>
					<div class="col text-ellipsis">{{ item.areaName }}</div>
					<div class="col">{{ item.protocol }}</div>
					<div class="col">{{ item.samplingInterval }}</div>
					<div class="col">{{ item.reportThreshold }}</div>
					<div class="col">
						<div class="op-btn" @click="modalClick(item)" :class="item.opClass">操作</div>
					</div>
				</div>
			</div>

			<!-- 在线离线图表 -->
			<div class="status-row">
				<div class="status-card">
					<div class="label">在线设备</div>
					<div id="onlineChart" class="chart"></div>
					<div class="desc">*实时采集，远程查看和参数维护</div>
				</div>
				<div class="status-card">
					<div class="label">离线设备</div>
					<div id="offlineChart" class="chart"></div>
					<div class="desc">离线设备列表，网关故障或设备状态</div>
				</div>
			</div>

			<!-- 操作记录 -->
			<div class="record-section">
				<div class="record-header">
					<span>最近设备操作记录</span>
					<span class="right-tip">点击每行"操作"进入设备控制弹窗</span>
				</div>
				<div class="record-list">
					<div class="record-item" v-for="(item, index) in command_recordsData.records" :key="index">
						<div class="time">{{ item.createTime }}</div>
						<div class="device text-ellipsis">{{ item.deviceName }}</div>
						<div class="action">{{ item.commandName }}</div>
						<div class="cost">{{ item.durationMs }}ms</div>
						<div class="status" :class="item.status">{{ item.statusName }}</div>
					</div>
				</div>
			</div>

			<!-- 底部统计卡片 -->
			<!-- 			<div class="bottom-card-box">
				<div class="stats-row">
					<div class="stat-item">
						<div class="num">92.3%</div>
						<div class="label">版本覆盖率</div>
					</div>
					<div class="stat-item">
						<div class="num">2台</div>
						<div class="label">今日升级</div>
					</div>
					<div class="stat-item">
						<div class="num">2台</div>
						<div class="label">待升级</div>
					</div>
					<div class="stat-item">
						<div class="num">99.2%</div>
						<div class="label">升级成功率</div>
					</div>
				</div>
				<div class="bottom-cards">
					<div class="bottom-card">
						<div class="label">命令模板</div>
						<div class="num">18台</div>
						<div class="desc">按传感器、网关、球机、门禁、电表、水表等类型自动匹配</div>
					</div>
					<div class="bottom-card">
						<div class="label">执行队列</div>
						<div class="num">18台</div>
						<div class="desc">批量下发、定时任务与待复核命令集中展示</div>
					</div>
					<div class="bottom-card">
						<div class="label">回执成功率</div>
						<div class="num">99.7%</div>
						<div class="desc">实时统计返回码、超时设备与异常原因</div>
					</div>
				</div>
			</div> -->
		</div>

		<!-- 原生弹窗 -->
		<div class="maintain-modal-overlay" v-if="visible" @click.self="handleClose">
			<div class="maintain-modal">
				<!-- 标题栏 -->
				<div class="modal-header">
					<div class="header-title">
						<div class="en-title">REMOTE MANAGEMENT</div>
						<div class="cn-title">远程管理</div>
					</div>
					<img class="close-btn" @click="handleClose" src="@/assets/close.png" alt="" />
				</div>

				<!-- 主体内容 -->
				<div class="modal-body">
					<div class="flex-start">
						<div>设备名称</div>
						<div>{{planForm.deviceName}}</div>
					</div>
					<div class="flex-start">
						<div>设备编号</div>
						<div>{{planForm.deviceCode}}</div>
					</div>
					<div class="flex-start" v-for="(item,index) in planForm.commands" :key="index">
						<div>{{item.name}}</div>
						<!-- 				<el-switch v-model="item.variable.type" active-color="#13ce66" inactive-color="#ff4949">
						</el-switch> -->
						<el-radio-group v-if="switchCommands.includes(item.command)" v-model="item.variable.type">
							<el-radio :label="item.variable.min">关</el-radio>
							<el-radio :label="item.variable.max">开</el-radio>
						</el-radio-group>
						<el-input v-if="inputCommands.includes(item.command)" v-model="item.variable.type"
							type="textarea" :rows="3" class="maintain-input" placeholder="请输入"></el-input>
						<el-input-number v-if="numberCommands.includes(item.command)" v-model="item.variable.type"
							:min="item.variable.min" :max="item.variable.max" label="描述文字"></el-input-number>
						<el-button size="mini" class="flex-end" type="primary"
							@click="handleConfirmPlan(item)">发送</el-button>
					</div>
					<!-- 					<div class="btn-group-1">
						<div class="btn primary-btn" @click="handleConfirmPlan">确定
						</div>
					</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import wsService from '@/utils/websocketService'
	import { getScreenScale } from '@/utils/rem'
	export default {
		name: 'deviceManagementRight',
		data() {
			return {
				visible: false,
				// 命令类型数组
				switchCommands: ['fan_switch', 'command', 'cover_switch', 'light_set', 'switch_switch', 'light_switch',
					'fan_oscillate'
				],
				inputCommands: ['media_player_set_value'],
				numberCommands: ['fan_set_percentage', 'cover_set_cover_position'],
				planForm: {
					deviceCode: "",
					command: "",
					variable: 1,
				},
				tabKey: "",
				onlineChart: null,
				offlineChart: null,
				deviceList: [],
				remote_maintenanceData: [],
				command_recordsData: {}
			};
		},
		mounted() {
			this.remote_maintenance();
			this.command_records()
			// 初始化设备 WebSocket
			// wsService.initDeviceWs(this.handleDeviceMessage)
		},
		beforeDestroy() {
			// wsService.unsubscribeDevice(this.handleDeviceMessage)
			// 销毁图表，防止内存泄漏
			if (this.onlineChart) this.onlineChart.dispose();
			if (this.offlineChart) this.offlineChart.dispose();
			window.removeEventListener('resize', this.resizeChart);
		},
		methods: {
			// 处理设备数据 WebSocket 消息
			handleDeviceMessage(message) {
				// console.log('[deviceManagementRight] 收到设备数据推送:', message)
				// 刷新设备列表和操作记录
				this.remote_maintenance()
				this.command_records()
			},
			remote_maintenance() {
				this.$http.get(this.$api.BASE_URL_Category.remote_maintenance).then(res => {
					this.remote_maintenanceData = res.data;
					if (res.data) {
						this.tabKey = res.data.deviceTypes[0].deviceType;
						this.deviceList = res.data.deviceTypes[0].devices;
					}
					this.initCharts();
				})
			},
			command_records() {
				this.$http.get(this.$api.BASE_URL_Category.command_records).then(res => {
					this.command_recordsData = res.data;
				})
			},
			modalClick(item) {
				this.planForm = item;
				console.log(item)
				this.visible = true;
			},
			handleClose() {
				this.visible = false;
				this.planForm = {
					deviceCode: "",
					command: "",
					variable: 1,
				};
			},
			handleConfirmPlan(item) {
				this.planForm.command = item.command;
				this.planForm.variable = item.variable.type;
				var obj = {
					commands: [{
						deviceCode: this.planForm.deviceCode,
						command: item.command,
						variable: item.variable.type,
					}]
				}
				this.$http.post(this.$api.BASE_URL_Category.commands, obj).then(res => {
					this.handleClose();
					this.$message.success(res.msg)
				})
			},
			
			tabClick(item) {
				this.tabKey = item.deviceType;
				this.deviceList = item.devices
			},
			initCharts() {
				// 初始化实例（仅一次）
				if (!this.onlineChart) {
					this.onlineChart = echarts.init(document.getElementById('onlineChart'));
					this.offlineChart = echarts.init(document.getElementById('offlineChart'));
				}
				this.renderCharts();

				// 监听窗口变化重绘（中心字号随屏幕缩放自适应）
				this.resizeChart = () => {
					this.onlineChart.resize();
					this.offlineChart.resize();
					this.renderCharts();
				};
				window.addEventListener('resize', this.resizeChart);
			},
			// 渲染在线/离线环形图（中心字号随屏幕缩放自适应）
			renderCharts() {
				const scale = getScreenScale();
				// 在线设备环形图
				this.onlineChart.setOption({
					series: [{
						type: 'pie',
						radius: ['70%', '85%'],
						avoidLabelOverlap: false,
						label: {
							show: false
						},
						data: [{
								value: this.remote_maintenanceData.onlineDeviceCount,
								itemStyle: {
									color: '#36bffa'
								}
							},
							{
								value: this.remote_maintenanceData.total - this.remote_maintenanceData
									.onlineDeviceCount,
								itemStyle: {
									color: 'transparent'
								}
							}
						]
					}],
					graphic: [{
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: `{num|${this.remote_maintenanceData.onlineDeviceCount}}{unit|台}`,
							fill: '#B3C8DC',
							rich: {
								num: {
									fontSize: Math.round(24 * scale),
									color: '#B3C8DC',
									fontWeight: 'bold'
								},
								unit: {
									fontSize: Math.round(10 * scale),
									color: 'rgba(255,255,255,0.4)',
									padding: [0, 0, 0, 2]
								}
							}
						}
					}]
				});

				// 离线设备环形图
				this.offlineChart.setOption({
					series: [{
						type: 'pie',
						radius: ['70%', '85%'],
						avoidLabelOverlap: false,
						label: {
							show: false
						},
						data: [{
								value: this.remote_maintenanceData.offlineDeviceCount,
								itemStyle: {
									color: '#ffc107'
								}
							},
							{
								value: this.remote_maintenanceData.total - this.remote_maintenanceData
									.offlineDeviceCount,
								itemStyle: {
									color: 'transparent'
								}
							}
						]
					}],
					graphic: [{
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: `{num|${this.remote_maintenanceData.offlineDeviceCount}}{unit|台}`,
							fill: '#B3C8DC',
							rich: {
								num: {
									fontSize: Math.round(26 * scale),
									color: '#B3C8DC',
									fontWeight: 'bold'
								},
								unit: {
									fontSize: Math.round(10 * scale),
									color: 'rgba(255,255,255,0.4)',
									padding: [0, 0, 0, 2]
								}
							}
						}
					}]
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.remote-management-page {
		width: 420px;
		color: #B3C8DC;
		position: absolute;
		top: 90px;
		right: 10px;
		z-index: 2;

		.section {
			width: 100%;
			height: 979px;
			padding: 10px;
			background: rgba(9, 23, 36, 0.9);
			border-radius: 12px;
					// border: 1px solid #4578A8;

			.header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 16px;

				.title {
					font-size: 16px;
					margin: 0;
				}

				.tip {
					font-size: 12px;
					color: #aaa;
				}
			}

			.tabs {
				display: flex;
				// overflow-x: auto;
				flex-wrap: wrap;
				gap: 8px;
				margin-bottom: 8px;
				cursor: pointer;

				.tab-btn {
					width: 93px;
					text-align: center;
					flex-shrink: 0;
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					color: #ccc;
							// border: 1px solid #4578A8;
					border-radius: 6px;
					padding: 8px 10px;
					font-size: 12px;

					&.active {
						background: #36bffa;
						color: #B3C8DC;
						border-color: #36bffa;
					}
				}
			}

			.device-table {
				padding: 5px 5px 0 5px;
				height: 280px;
				overflow-y: auto;
				background: linear-gradient(0deg, #081724 0%, #16283A 100%);
				border-radius: 7px;
						// border: 1px solid #4578A8;
				margin-bottom: 10px;

				.table-header {
					display: flex;
					background: rgba(0, 0, 0, 0.2);
					padding: 10px 0 10px 10px;
					font-size: 12px;
					color: #B3C8DC;
					border-radius: 7px 7px 0 0;
					.col {
						flex: 1;
						text-align: center;
					}
				}

				.table-row {
					position: relative;
					display: flex;
					align-items: center;
					padding: 6px 0 6px 10px;
					background: linear-gradient(0deg, rgba(122, 191, 255, 0.2) 0%, rgba(14, 30, 45, 0.1) 100%);
					border-radius: 7px;
					border: 1px solid #7ABFFF;
					margin-bottom: 8px;

					&.upgrading {
						background: linear-gradient(0deg, rgba(255, 190, 74, 0.5) 0%, rgba(14, 30, 45, 0.1) 100%);
						border: 1px solid #FFBE4A;
					}

					&:last-child {
						// border-bottom: none;
					}

					.col {
						flex: 1;
						text-align: center;
						font-size: 10px;

						.version-tag {
							position: absolute;
							top: 0;
							left: 0;
							padding: 2px 5px;
							color: #450000;
							font-size: 8px;
							background: #FFBE4A;
							border-radius: 7px 0 7px 0;
							border: 1px solid #FFDEA3;

							&.latest {
								background: #409CF1;
								border-color: #7ABFFF;
							}

							&.upgrading {
								background: #FFBE4A;
								border-color: #FFDEA3;
							}
						}
					}

					.op-btn {
						cursor: pointer;
						width: 30px;
						height: 16px;
						margin: 0 auto;
						line-height: 12px;
						background: #50A4FC;
						border-radius: 3px;
						color: #B3C8DCFFF;
						border: 1px solid #7ABFFF;

						&.blue {
							background: #50A4FC;
							border: 1px solid #7ABFFF;
						}

						&.yellow {
							background: #FFBE4A;
							border: 1px solid #FFBE4A;
						}
					}
				}
			}

			.status-row {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 8px;

				.status-card {
					width: 194px;
					height: 124px;
					padding: 5px 10px;
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					border-radius: 4px;
							// border: 1px solid #4578A8;

					.chart {
						width: 70px;
						height: 70px;
						margin: 0 auto 8px;
					}

					.label {
						font-size: 12px;
						color: #B3C8DC;
						margin-bottom: 6px;
					}

					.desc {
						font-size: 10px;
						color: #B3C8DC;
						text-align: center;
					}
				}
			}

			.record-section {
				width: 399px;
				height: 420px;
				background: linear-gradient(0deg, #081724 0%, #16283A 100%);
				border-radius: 7px;
						// border: 1px solid #4578A8;
				padding: 12px 10px;
				margin-bottom: 10px;

				.record-header {
					display: flex;
					justify-content: space-between;
					margin-bottom: 10px;
					font-size: 12px;

					.right-tip {
						color: #B3C8DC;
						font-size: 10px;
					}
				}

				.record-list {
					height: 380px;
					overflow-y: auto;

					.record-item {
						display: flex;
						align-items: center;
						justify-content: space-between;
						padding: 5px 0;
						font-size: 10px;
						background: linear-gradient(0deg, rgba(122, 191, 255, 0.2) 0%, rgba(14, 30, 45, 0.1) 100%);
						border-radius: 6px;
						border: 1px solid #7ABFFF;
						margin-top: 8px;
						text-align: center;

						div {
							line-height: 13px;
							width: 20%;
						}


						.status {
							color: #5FE3FF;
						}
					}
				}
			}
		}

		.bottom-card-box {
			width: 399px;
			height: 172px;
			padding: 11px;
			background: linear-gradient(0deg, #081724 0%, #16283A 100%);
			border-radius: 8px;
					// border: 1px solid #4578A8;

			.stats-row {
				width: 100%;
				margin: 0 auto;
				display: flex;
				align-items: center;
				text-align: center;
				justify-content: space-around;
				padding: 0 0 14px 0;
				border-bottom: 1px solid #3C5E7D;
				margin-bottom: 10px;

				.stat-item {
					width: 25%;
					border-right: 1px solid #25394C;

					.num {
						font-size: 22px;
						margin-bottom: 5px;

						span {
							font-size: 10px;
							color: #B3C8DCFFF;
							margin-left: 2px;
						}
					}

					.label {
						font-size: 10px;
						color: #B3C8DC;
					}
				}

				.stat-item:last-child {
					border: none;
				}
			}

			.bottom-cards {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 10px;

				.bottom-card {
					background: linear-gradient(0deg, #081724 0%, #16283A 100%);
					border-radius: 7px;
							// border: 1px solid #4578A8;
					padding: 6px 9px;

					.label {
						font-weight: bold;
						font-size: 10px;
						color: #B3C8DCFFF;
					}

					.num {
						margin: 5px 0;
						font-weight: 800;
						font-size: 16px;
						color: #B3C8DCFFF;
					}

					.desc {
						font-weight: 500;
						font-size: 9px;
						color: #B3C8DC;
						line-height: 12px;
					}
				}
			}
		}

		.maintain-modal-overlay {
			position: fixed;
			top: 500px;
			left: 50%;
			transform: translate(-50%, 0);
			width: 100%;
			width: 100%;
			height: 100%;
			background: rgba(0, 15, 35, 0.75);
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 9999;

			.maintain-modal {
				width: 850px;
				background: rgba(9, 23, 36, 0.9);
				border-radius: 12px;
						// border: 1px solid #4578A8;
				padding: 11px 19px;
				font-size: 12px;

				.modal-header {
					display: flex;
					justify-content: space-between;
					align-items: flex-start;
					margin-bottom: 20px;

					.header-title {
						.en-title {
							font-size: 12px;
							color: #7ABFFF;
							margin-bottom: 8px;
						}

						.cn-title {
							font-weight: 500;
							font-size: 16px;
							color: #B3C8DC;
						}
					}

					.close-btn {
						cursor: pointer;
						width: 24px;
						height: 24px;
					}
				}

				.modal-body {
					.flex-start {
						display: flex;
						align-items: center;
						gap: 12px;
						margin-bottom: 16px;

						&>div:first-child {
							width: 100px;
							color: #B3C8DC;
							font-size: 12px;
							text-align: right;
						}
					}

					::v-deep .maintain-input {
						flex: 1;
						min-width: 200px;

						.el-input__inner {
							background: rgba(9, 23, 36, 0.9);
							border: 1px solid #7ABFFF;
							color: #B3C8DC;
						}

						.el-date-editor.el-input__inner {
							background: rgba(9, 23, 36, 0.9);
							border: 1px solid #7ABFFF;
							color: #B3C8DC;
						}

						textarea.el-input__inner {
							padding: 8px;
						}
					}

					::v-deep .el-picker-panel {
						background: #091724;
								// border: 1px solid #4578A8;
					}

					::v-deep .el-picker-panel__content {
						color: #B3C8DC;
					}

					.btn-group-1 {
						display: flex;
						gap: 26px;
						justify-content: center;
						margin-bottom: 20px;
						align-items: center;

						.btn {
							width: 110px;
							height: 40px;
							line-height: 38px;
							text-align: center;
							background: #172434;
							border-radius: 10px;
							border: 1px solid #2C3D52;
							font-size: 16px;
							color: #B3C8DC;
							cursor: pointer;

							&.primary-btn {
								color: #349DFF;
								border: 1px solid #349DFF;
								background-color: transparent;
							}

							&:hover {
								color: #349DFF;
								border: 1px solid #349DFF;
								background-color: transparent;
							}
						}
					}
				}

				.modal-body2 {
					.flex-start {
						margin-top: 40px;
					}
				}
			}
		}
	}
</style>